/**
 * Returns `true` if the param is a File instance
 * @param file {object}
 * @return {boolean}
 */
export const isFile = (file) => file instanceof File;
